// La moneda del anuncio: una sola para el anuncio, sus alojamientos y sus tarifas.
export const monedaAnuncio = {
  chipTitle: "Valuta dell'annuncio",
  change: "Cambia",
  mismatchDot: "Le valute di questo annuncio non coincidono",
  channexText: "Questo annuncio è collegato a Channex. Lì la valuta di una tariffa non si può cambiare: va ricreata. Scrivici e lo facciamo senza interrompere le tue vendite sulle OTA.",
  channexOnly: "È collegato a Channex: può usare solo {currency}, la valuta delle sue tariffe lì.",
  modal: {
    title: "Valuta dell'annuncio",
    lead: "È la valuta in cui incassi dagli ospiti di questo annuncio.",
    scope: "Cambia contemporaneamente per l'annuncio, tutte le sue strutture e le sue tariffe. I link di pagamento, l'agente IA e il late checkout useranno questa valuta.",
    label: "Valuta",
    mismatch: "Al momento non coincidono: l'annuncio indica {listing} e le sue strutture incassano in {units}. Salvando, sarà tutto nella stessa.",
    channexTitle: "Non si può cambiare da qui",
    cancel: "Annulla",
    close: "Ho capito",
    save: "Salva",
    saving: "Salvataggio…",
    saved: "Valuta dell'annuncio aggiornata a {currency}.",
    error: "Impossibile cambiare la valuta. Riprova.",
  },
  sugerencia: {
    titleCountry: "Questo annuncio incassa in {current}",
    textCountry: "In {country} di solito si paga in {suggested}. Se la cambi, i link di pagamento, l'agente IA e il late checkout useranno {suggested}.",
    titleMismatch: "Le valute di questo annuncio non coincidono",
    textMismatch: "L'annuncio indica {listing} e le sue strutture incassano in {units}. Tienine una sola, così ciò che annuncia l'IA e ciò che si incassa coincidono.",
    useSuggested: "Passa a {currency}",
    other: "Scegline un'altra",
    keep: "Mantieni {currency}",
  },
};
